import React, { useEffect, useState } from "react";
import { Typography, Space } from "antd";

const { Text } = Typography;

const StatusBadge = ({ status, lastEdited }) => {  
  // let isDraft = status === "NA";
  // let isActive = status === 1;
  let inActive = status === 0;
  const [isDraft , setIsDraft] = useState("NA")
    const [isActive , setIsActive] = useState(1)
   useEffect(() => { 
    
    if (status == 1) {
      setIsActive(1)
      setIsDraft("")
    }else if (status == 0){
      setIsActive(0)
      setIsDraft("")
    }
   },[status]);

  // if (isDraft) return null;

  return (
    <>
    {isDraft !==  "NA" && 
      <div style={{ display: "flex", flexDirection: "column", paddingBottom: "16px" }}>
        <Space size="small" align="center">
          <span
            style={{
              height: 8,
              width: 8,
              backgroundColor: isDraft ? "#bfbfbf" : (isActive?"#52C41A":"red"),
              borderRadius: "50%",
              display: "inline-block",
            }}
          />
          <Text strong>{isDraft ? "Draft" :  (isActive?"Active":"InActive") }</Text>
        </Space>
        <Text type="secondary" style={{ fontSize: 12, marginLeft: 14 }}>
          Last edited {lastEdited || "N/A"}
        </Text>
      </div>
    }
    </>
  );
};

export default StatusBadge;
